import { PersonalInformation } from 'types/kyc-identities-types';

export const getPersonalInformationData = (
  personalInformation?: PersonalInformation
) => {
  return [
    {
      key: 'Name',
      value: personalInformation?.name,
    },
    {
      key: 'Email',
      value: personalInformation?.email,
    },
    {
      key: 'Phone',
      value: personalInformation?.phoneNumber?.number,
    },
    {
      key: 'Address',
      value: personalInformation?.address?.displayAddress,
    },
  ];
};
